// src/shared/dom.js — градивните DOM помощници (копие от app.js, Фаза 3).
// ЧИСТИ функции: копирани са, не мостнати. app.js пази своите копия до 3.3;
// двете живеят паралелно без конфликт, защото не държат състояние.

export function el(tag, attrs, ...kids) {
  const node = document.createElement(tag);
  if (attrs) {
    for (const k in attrs) {
      const v = attrs[k];
      if (v == null || v === false) continue;
      if (k === 'class') node.className = v;
      else if (k === 'text') node.textContent = v;
      else if (k === 'html') node.innerHTML = v;
      else if (k === 'value') node.value = v;
      else if (k === 'checked') node.checked = !!v;
      else if (k.startsWith('on') && typeof v === 'function') node.addEventListener(k.slice(2).toLowerCase(), v);
      else node.setAttribute(k, v);
    }
  }
  for (const kid of kids.flat()) {
    if (kid == null || kid === false) continue;
    node.appendChild(typeof kid === 'string' || typeof kid === 'number' ? document.createTextNode(String(kid)) : kid);
  }
  return node;
}

export function clear(n) { while (n.firstChild) n.removeChild(n.firstChild); }
export function $(sel) { return document.querySelector(sel); }
export function initials(name) { return (name || '?').trim().split(/\s+/).map((w) => w[0]).slice(0, 2).join('').toUpperCase(); }

// Надписът СЕ СВЪРЗВА с полето (label[for] ↔ input#id). Без това екранният
// четец чете само „празна кутийка": надписът стои до полето, но не му
// принадлежи. Идентификаторът се раздава автоматично, за да не се пипат
// стотиците повиквания на field() из екраните.
let fieldSeq = 0;
// opts.size: 's' (дата, валута, процент) или 'm' (кратък текст) — полето
// спира да се разпъва до цялата колона. Без size остава широко (текст).
export function field(label, input, opts) {
  // field() понякога получава обвивка (поле + бутон до него) вместо самото
  // поле — тогава търсим полето вътре.
  const target = (input && input.matches && input.matches('input,select,textarea'))
    ? input
    : ((input && input.querySelector && input.querySelector('input,select,textarea')) || input);
  if (target && target.setAttribute && !target.id) target.id = 'fld-' + (++fieldSeq);
  const labelEl = (target && target.id)
    ? el('label', { for: target.id, text: label })
    : el('label', { text: label });
  const size = opts && opts.size ? ' sz-' + opts.size : '';
  return el('div', { class: 'field' + size }, labelEl, input);
}
export function input(attrs) { return el('input', attrs); }
export function row(...fields) { return el('div', { class: 'field-row' }, ...fields); }

// Ред от таблица, който се отваря с клик — но и с клавиатура.
// <tr onclick> сам по себе си не се фокусира и не се обявява като нещо
// натискаемо, тоест списъците бяха достъпни само с мишка: човек на
// клавиатура виждаше записите, но не можеше да отвори нито един.
//   clickableRow(() => contactDetail(c), 'Отвори ' + c.name, …клетки)
// Клетка (или друг елемент), която се натиска: Tab стига до нея, Enter и
// интервал правят същото като клик, а екранният четец чете label. Работната
// бланка беше само с мишка — а там се въвеждат данните (рецензия 27.10.2026).
export function pressable(node, onPress, label) {
  node.setAttribute('tabindex', '0');
  node.setAttribute('role', 'button');
  if (label) node.setAttribute('aria-label', label);
  node.addEventListener('click', onPress);
  node.addEventListener('keydown', (e) => {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    if (e.target !== node) return;
    e.preventDefault();
    onPress(e);
  });
  return node;
}

export function clickableRow(onOpen, label, ...cells) {
  const tr = el('tr', {
    tabindex: '0', role: 'button', 'aria-label': label || 'Отвори реда',
    onClick: onOpen,
    onKeydown: (e) => {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      // Отметката и бутоните ВЪТРЕ в реда си пазят собственото поведение.
      if (e.target !== tr) return;
      e.preventDefault();
      onOpen();
    },
  }, ...cells);
  return tr;
}
